import domReady from 'domReady'
import $ from 'jquery'
import bootstrap from 'bootstrap'
import _ from 'lodash'
import purify from './purify'
import selectize from 'selectize'
import notify from './notify'
import csrf from './csrf'

import alert from './alert'
import soundRecord from './sound-record'
import speaker from './speaker'
import './autonod'
import colorpicker from './color-picker'

import cookie from './cookie'

import text from './text'
import autoselectize from './autoselectize'
import chart from './my-chart'
import datepicker from './date-picker'
import toggle from './toggle'
import multilanguagepopup from './multilanguagepopup'
import sorcier from './sorcier'
import upload from './upload'
import multiLangEditor from './multi-lang-editor'
import editor from './editor'
import yp from './yp'
import table from './table'
import sortable from './sortable'

import './css/anim.css'

if (typeof ctx === 'undefined') {
  window.ctx = '/'
}
if (typeof lang === 'undefined') {
  window.lang = 'en'
}

var _load_ = false

domReady(function () {
  window.yp = yp
  window.jQ = $
  window.installHandlers = installHandlers
  _load_ = false
  window._finders_ = 0
  console.log('domReady')
  installHandlers(document)
})

function installHandlers(context) {

  $('.logout_form', context).each(function () {
    var $this = $(this)
    console.log('logout form found with handler')
    $this.submit(function (evt, data) {
      data = data || {}
      if (data.confirmed === true) {
        return true
      } else {
        evt.preventDefault()
      }
      alert('misc.auth.logout.warn', function () {
        notify.clear()
        $this.trigger('submit', { confirmed: true })
      })
    })
  })

  $('body.evaluationGroup_by_speaker .page-title', context).click(function () {
    history.back()
  })
  $('body.evaluationGroup .page-title', context).click(function () {
    history.back()
  })

  $('button.popup:not(".custom-js"),a.popup:not(".custom-js")', context).click(function () {
    notify.clear()
    yp.handlePopup($(this))
    return false
  })

  $('button.popup.custom-js.create-question', context).click(function () {
    var button = $(this)
    var url = $(this).closest('form').attr('action').replace(/\/[^/]+$/, '/question/create?json')
    $.ajax({
      url: url,
      headers: csrf(),
      type: 'POST',
      dataType: 'json',
      data: {
        'question.text': text('misc.empty.question'),
        'question.summary': text('misc.empty.summary'),
        'question.type': 'CATEGORY',
        'question.evaluation': 'LINEAR',
      },
      success: function (e) {
        console.log('creation succeeded, lets go to ' + e.redirection)
        notify.clear()
        yp.handlePopup(button, e.redirection + '?pageStyle=popup')
      },
    })
    return false
  })

  $('button.popin,a.popin', context).click(function () {
    notify.clear()
    yp.handlePopin($(this))
    return false
  })

  $('.crud-form:not(".custom-submit")', context).each(function () {
    console.log('crud form found:')
    console.log(this)
    $(this).submit(function (e, params) {
      params = params ? params : {}
      if (params.executeDefault) {
        return 1
      }
      e.preventDefault()
      var $this = $(this)

      var action = params.action ? params.action : $this.find('.crud_action').val()
      if (!action) {
        console.error('Neither params.action nor a .crud_action input element were defined')
        return false
      }
      if ($this.hasClass('validation-blocks-submit') && $this.data('autonod') !== undefined) {
        if ($this.data('autonod').checkAll() === false) {
          return
        }
      }

      function submitIt(params) {
        $this.data('serial', null)
        console.log('crud form submitting to ' + action)
        console.log('disabling submit buttons')
        $('.btn-submit,.down-btn-submit', $this).prop('disabled', true)
          .addClass('to-be-reenabled')
        var $button = $(document.activeElement)
        notify.clear()
        var params = $.extend({ context: context, $form: $this }, params)
        $.ajax({
          url: action,
          type: 'POST',
          dataType: 'json',
          headers: csrf(),
          success: yp.showCrudResponse(params),
          error: yp.showAjaxError(params),
          data: yp.serialize($this),
          context: $this,
        })
      }

      var a = $('#alert-message')
      if (a.length > 0) {
        console.log('ALERT - [' + a.html() + ']')
        alert(a.html(), function () {
          submitIt(params)
        })
      } else {
        console.log('NO ALERT')
        submitIt(params)
      }
    })
  })

  $('.find-form:not(".custom-submit")', context).each(function () {
    console.log('find form found: ')
    console.log(this)
    $(this).submit(function (e, params) {
      var $this = $(this)
      params = params ? params : {}
      var action = params.action ? params.action : $this.attr('action') + '?json'
      if (!action) {
        console.error('Neither params.action nor form.action were defined')
        return false
      }
      console.log('find form submitting to: ' + action)
      var $table = $this.find('table')
      notify.clear()
      if (params.download === true) {
        console.log('csv/xlsx download')
        $this.prop('action', action)
        return true
      } else if ($table.hasClass('table-server-paginated')) {
        console.log('datatables refresh')
        var handler = $table.data('y')
        handler.refresh()
      } else {
        console.log('datatables reload')
        var handler = $table.data('y')
        handler.reload()
      }

      return false
    })

    $(this).find('[name="_reset"]').each(function () {
      console.log('find form reset button redirecting to ' + $(this).data('url'))
      $(this).click(function (e) {
        window.location.href = $(this).data('action')
        return false
      })
    })
  })

  $('.ajax_delete', context).each(function () {
    $(this).click(function () {
      var msg = 'misc.confirm.delete'
      msg = text(msg)
      if (!confirm(msg)) {
        this.blur()
        return false
      }
      notify.clear()
      $.ajax({
        url: this.value,
        type: 'POST',
        dataType: 'json',
        headers: csrf(),
        success: yp.updateOnDelete,
        error: yp.showAjaxError(),
        context: this,
      })
      return false
    })
  })

  if ($('.selecttag', context).length !== 0) {
    console.log('found selecttag, loading selectize')
    $('.selecttag', context).each(function (i, s) {
      $(s).selectize({
        copyClassesToDropdown: false,
        allowEmptyOption: $(s).hasClass('empty_option'),
        plugins: ['remove_button', 'restore_on_backspace'],
        create: true,
        selectOnTab: true,
        render: {
          option_create: function (data, escape) {
            return '<div class="create">' + text('misc.add') +
              ' <strong>' + escape(data.input) + '</strong>&hellip;</div>'
          },
        },
        onInitialize: function () {
          console.log('onInitialize')
          $(s).find('+.selectize-control').removeClass('form-control')
          $(s).find('+.selectize-control input').attr('role', 'presentation')
        },
      })
    })
  }

  var selectizeType1 = 'select:not(".autoselect,.selecttag,.color-picker")'
  if ($(selectizeType1, context).length !== 0) {
    console.log('found selects without autocomplete, loading selectize')
    $(selectizeType1, context).each(function (i, s) {
      $(s).selectize({
        copyClassesToDropdown: false,
        allowEmptyOption: $(s).hasClass('empty_option'),
        plugins: ['remove_button', 'restore_on_backspace'],
        create: false,
        selectOnTab: true,
        searchField: ['name'],
        labelField: ['name'],
        valueField: ['id'],
        onInitialize: function () {
          console.log('onInitialize')
          $(s).find('+.selectize-control').removeClass('form-control')
          $(s).find('+.selectize-control input').attr('role', 'presentation')
        },
      })
      yp.initSelectHideOnChange(s)
    })
  }

  if ($('input[type=checkbox].hideonchange', context).length !== 0) {
    console.log('found checkbox with hideonchange')
    $('input[type=checkbox].hideonchange', context).each(function (i, s) {
      yp.initCheckboxHideOnChange(s)
    })
  }

  $('.toggle-group', context).each(function (x, y) {
    toggle(y)
  })

  $('select.autoselect', context).each(function (i, s) {
    autoselectize.init({
      ctx: ctx,
      elem: $(s),
      onAjaxError: yp.showAjaxError(),
    })
  })

  $('.popover-element', context).popover()
  $('.tooltip-element', context).tooltip({ container: 'body' })
  $('.dropdown-toggle', context).dropdown()

  $('textarea.htmleditor', context).each(function () {
    var $this = $(this)
    editor.init(this, ctx, lang, undefined, function () {
      console.log('initFinCallback for editor:')
      console.log($this)
      $this.parents('form.crud-form').each(function () {
        yp.updateFormInitialData(this)
      })
    })
  })

  $('.datepicker[readonly!="readonly"]', context).each(function (x, y) {
    datepicker(y)
  })

  $('.module-notes', context).each(function () {
    var $notifyBtn = $(this).find('.btn-notify-notes')
    $('body').on('crudResponse', function (e, who) {
      var $who = $(who)
      if ($who.hasClass('note-create')) {
        if ($who.find('[name="notify_company"]').is(':checked')) {
          yp.setButtonState($notifyBtn, 'execute')
        } else {
          yp.setButtonState($notifyBtn, 'init')
        }
      }
    })
  })

  $('.datatablez:not(".custom-init")', context).each(function () {
    var $this = $(this)
    if ($this.data('y')) {
      return
    }
    var $form = $this.closest('.pageform')
    _finders_++
    console.debug('_finders_=' + _finders_)
    var findTable = table.init({
      ctx: ctx,
      lang: lang,
      server: true,
      useViews: true,
      thead: $this.data('thead'),
      parameterPrefix: $this.data('parameter-prefix'),
      successCallback: yp.showFindResponseErrors($form, $this),
      errorCallback: yp.showAjaxError(),
      clickonrow: $this.data('entity-url-template') !== undefined,
      clicktoselect: $this.data('click-to-select') === true ? true : false,
      middleclickonrow: $this.data('middle-click-url-template') !== undefined,
      updateRowUrl: $this.data('update-row-url') || undefined,
      pageLength: $this.data('page-length') || undefined,
      order: $this.data('order') || undefined,
      $counter: $this.data('counter-selector') ?
      $($this.data('counter-selector')) : undefined,
      query: function () {
        return {
          url: $('input[type="submit"]', $form).data('action'),
          type: 'POST',
          dataType: 'json',
          headers: csrf(),
          data: yp.serialize($form),
          context: $form,
        }
      },
      elem: $this,
    })
    $this.data('y', findTable)
  })

  $('.table-notes-list-all', context).each(function () {
    var $this = $(this)
    if ($this.data('y')) {
      return
    }
    var $form = $this.closest('.pageform')
    _finders_++
    console.debug('_finders_=' + _finders_)
    var t = table.init({
      dom: 'ftip',
      pageLength: 10,
      ctx: ctx,
      lang: lang,
      fixedData: true,
      pageLength: $this.data('page-length') || undefined,
      elem: $this,
    })
    $this.data('y', t)
  })

  $('.multi-lang-editor', context).each(function () {
    var $this = $(this)
    multiLangEditor.init({
      elem: $this,
      ctx: ctx,
      initFinCallback: function (D) {
        console.log('initFinCallback for multi-lang-editor:')
        console.log($this)
        $this.parents('form.crud-form').each(function () {
          yp.updateFormInitialData(this)
        })
      },
      lang: lang,
    })
  })

  $('.wizard', context).each(function (e) {
    sorcier.init({
      ctx: ctx,
      elem: $(this),
      focusOnFirst: false,
      buttonSanitizer: function (x) {
        return purify.button(x)
      },
    })
    $(this).removeClass('hide')
  })

  $('div.inline-page', context).each(function () {
    yp.loadInlinePage(this)
  })

  if ($('form', context).length !== 0) {
    console.log('form validation via js')
    $('form', context).each(function () {
      var $form = $(this)
      $form.data('autonod', $form.autonod({
        addError: yp.addValidationError,
        removeError: yp.removeValidationError,
      }))
    })
  }

  $('.fileupload', context).each(function (e) {
    var $this = $(this)
    upload.init({
      ctx: ctx,
      elem: $this,
      initFinCallback: function () {
        console.log('initFinCallback for fileupload:')
        console.log($this)
        $this.parents('form.crud-form').each(function () {
          yp.updateFormInitialData(this)
        })
      },
      yp: yp,
    })
  })

  $('button.btn-bulk', context).each(function () {
    var $b = $(this)
    var bulkVerb = $b.data('bulk-verb')
    var $form = $('form.bulk-source')
    var $bulkButton = $form.find('[name="bulk"]')
    var bulkAction = $bulkButton.data('action').replace('_bulk_action', bulkVerb)
    var $secondaryForm = undefined
    if ($b.hasClass('btn-bulk-with-params')) {
      $secondaryForm = $b.closest('form')
    }
    $b.click(function (e) {
      e.preventDefault()
      if ($b.data('confirm') === true) {
        var msg = 'misc.confirm.generic'
        if ($b.data('confirm-msg')) {
          msg = $b.data('confirm-msg')
        }
        msg = text(msg)
        if (!confirm(msg)) {
          $b.blur()
          return false
        }
      }
      if ($b.hasClass('btn-bulk')) {
        console.log('Modification protection for bulk-source forms: check')
        var d1 = $form.data('serial')
        if (d1 != null && d1 != '') {
          var d2 = yp.serialize($form)
          if (d1 != d2) {
            $b.blur()
            alert(text('misc.confirm.finderModified'))
            return false
          }
        }
      }
      console.log('bulk action submitting: ' + bulkAction)
      if ($secondaryForm !== undefined) {
        $secondaryForm.data('serial', null)
      }
      console.log('disabling submit buttons')
      $b.prop('disabled', true).addClass('to-be-reenabled')
      $('.btn-find', $form).prop('disabled', true).addClass('to-be-reenabled')
      notify.clear()
      var params = {
        context: context,
        $form: $form,
        $secondaryForm: $secondaryForm,
      }
      $.ajax({
        url: bulkAction,
        type: 'POST',
        dataType: 'json',
        headers: csrf(),
        success: yp.showCrudResponse(params),
        error: yp.showAjaxError(params),
        data: yp.serialize($form) +
          ($secondaryForm === undefined ? '' : ('&' + yp.serialize($secondaryForm))),
        context: $form,
      })
    })
  })

  $('button.btn-action', context).each(function () {
    var $b = $(this)
    $b.data('action', $b.data('init-action'))
    $b.data('href', $b.data('init-href'))
    $b.click(function (evt) {
      var action = $b.data('action')
      var href = $b.data('href')
      function runInitAction() {
        $b.prop('disabled', true)
          .data('original-html', $b.html())
          .data('original-action', action)
          .text(purify.button($b.data('loading-html')))
        notify.clear()
        $.ajax({
          url: action,
          type: 'POST',
          dataType: 'json',
          headers: csrf(),
          success: yp.showButtonResponse($b),
          error: yp.showButtonAjaxError($b),
        })
      }
      if (action !== undefined && !_.isEmpty(action)) {
        if ($b.data('confirm') === true) {
          var msg = 'misc.confirm.generic'
          if ($b.data('confirm-msg')) {
            msg = $b.data('confirm-msg')
          }
          msg = text(msg)
          if (!confirm(msg)) {
            $b.blur()
            return false
          }
          runInitAction()
          return false
        } else if ($b.data('alert') !== undefined) {
          console.log('ALERT - [' + $b.data('alert') + ']')
          alert($b.data('alert'), function () {
            runInitAction()
          })
        } else {
          runInitAction()
          return false
        }
      } else if (href !== undefined && !_.isEmpty(href)) {
        if ($b.data('alert') !== undefined) {
          console.log('ALERT - [' + $b.data('alert') + ']')
          alert($b.data('alert'), function () {
            console.log('User did confirm! Redirecting to: ' + href)
            window.location.href = href
          })
        } else {
          console.log('Redirecting to: ' + href)
          window.location.href = href
        }
        return false
      }
    })
  })

  $('button.btn-self-remove', context).each(function () {
    var $b = $(this)
    $b.data('action', $b.data('init-action'))
    $b.click(function (evt) {
      var action = $b.data('action')
      if ($b.data('confirm') === true) {
        var msg = 'misc.confirm.generic'
        if ($b.data('confirm-msg')) {
          msg = $b.data('confirm-msg')
        }
        msg = text(msg)
        if (!confirm(msg)) {
          $b.blur()
          return false
        }
      }
      $b.prop('disabled', true)
      notify.clear()
      $.ajax({
        url: action,
        type: 'POST',
        dataType: 'json',
        headers: csrf(),
        success: yp.showSelfRemoveButtonResponse($b),
        error: yp.showButtonAjaxError($b),
      })
      return false
    })
  })

  $('button.btn-submit:not(".btn-popup")', context).each(function () {
    var t = $(this)
    var action = t.data('action')
    if (action) {
      t.click(function (evt) {
        if (t.data('confirm') === true) {
          var msg = 'misc.confirm.generic'
          if (t.data('confirm-msg')) {
            msg = t.data('confirm-msg')
          }
          msg = text(msg)
          if (!confirm(msg)) {
            t.blur()
            return false
          }
        }
        notify.clear()
        var $form = $(this).closest('form')
        $form.data('button-pressed', t)
        evt.preventDefault()
        $form.trigger('submit', {
          action: action,
        })
      })
    }
  })

  $('.btn-post-link', context).each(function () {
    var t = $(this)
    t.click(function (evt) {
      notify.clear()
      evt.preventDefault()
      var $form = $(this).closest('form')
      $form.trigger('submit')
    })
  })

  $('button.btn-download', context).each(function () {
    var t = $(this)
    var action = t.data('action')
    if (action) {
      t.click(function (evt) {
        notify.clear()
        var $form = $(this).closest('form')
        $form.data('button-pressed', t)
        evt.preventDefault()
        t.blur()
        var dataType = t.hasClass('btn-download-xlsx') ?
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv'
        $form.trigger('submit', {
          action: action,
          download: true,
          dataType: dataType,
        })
      })
    }
  })

  $('button.btn-submit.btn-popup.multilanguagepopup', context).each(function () {
    var $t = $(this)
    var action = $t.data('action')
    var $form = $(this).closest('form')
    if (action) {
      var mp = multilanguagepopup.init($t, $('#modal'), yp, { PURIFY_MSG_DATA: false })
      $t.click(function (evt) {
        notify.clear()
        $form.trigger('submit', {
          who: $t,
          successCallback: mp.successCallback,
          action: action,
        })
      })
    }
  })

  $('button.btn-default-submit', context).each(function () {
    var $form = $(this).closest('form')
    var $t = $(this)
    $t.click(function (evt) {
      evt.preventDefault()
      if ($t.data('confirm') === true) {
        var msg = 'misc.confirm.generic'
        if ($t.data('confirm-msg')) {
          msg = $t.data('confirm-msg')
        }
        msg = text(msg)
        if (!confirm(msg)) {
          $t.blur()
          return false
        }
      }
      notify.clear()
      $form.trigger('submit', {
        executeDefault: true,
      })
    })
  })

  $('select.clearonchange', context).each(function () {
    var $source = $(this)
    var targets = $source.data('clearonchange')
    if (targets !== undefined && !_(targets).isEmpty()) {
      _(targets).each(function (e) {
        var $target = $('select[name="' + e + '"]')
        $source.change(function (evt) {
          if ($target[0] === undefined) return
          var sl = $target[0].selectize
          if (sl === undefined) return
          sl.clear()
          sl.clearOptions()
        })
      })
    }
  })

  $('select.removeonchange', context).each(function () {
    var $source = $(this)
    var targets = $source.data('removeonchange')
    if (targets !== undefined && !_(targets).isEmpty()) {
      _(targets).each(function (e) {
        var $target = $('select[name="' + e + '"]')
        $source.change(function (evt) {
          if (!_($source.val()).isEmpty()) {
            if ($target[0] === undefined) return
            var sl = $target[0].selectize
            if (sl === undefined) return
            sl.removeOption($source.val())
          }
        })
      })
    }
  })

  $('.add_field').click(function () {
    var name = $(this).data('name')
    var insert = $(this).data('value')
    var elem
    if ($(this).data('multilanguage') !== true) {
      elem = $('[name="' + name + '"]')
    } else {
      elem = $($('[name="' + name + '"] ~.nav-tabs li.active a').attr('href') + '-ta')
    }

    console.log('name: ' + name)
    console.log('insert: ' + insert)
    console.log('size: ' + elem.length)
    if (elem.length === 0) {
      console.error('could not find element with name ' + name)
      return
    }
    var editor = elem.data('ckeditor')
    var img = editor.document.createElement('img')
    img.setAttribute('src', ctx + '/img/edit/' + lang + '/' + insert + '.png')
    img.setAttribute('altid', $(this).data('txtid'))
    img.setAttribute('alt', $(this).data('txt'))
    editor.insertElement(img)
  })

  if ($('#template_right_add').length != 0) {
    $('#template_right_add').click(function () {
      var $b = $(this)
      if ($b.parents('form').data('autonod').checkAll() === false) {
        $b.blur()
        return
      }
      var v = $('select[name*=template\\.right\\.name]')
      $.get(ctx + '/y/legaltemplate/' + v.val() + '/view?json', {},
        function (data, status, xhr) {
          if (status == 'success') {
            //console.log(data.data.text)
            var elem = $('[name="legalAgreement.text"]')
            if (elem.length === 0) {
              console.error('could not find element with name legalAgreement.text')
              return
            }
            var editor = elem.data('ckeditor')
            var _text = data.data.text.replace(/\/img\/edit\/..\//g, '/img/edit/' + lang + '/')
            if (!editor.checkDirty()) {
              editor.setData(_text)
            } else {
              if (confirm(text('legalagreement.text.replace'))) {
                editor.setData(_text)
              }
            }
          }
          $b.blur()
        }, 'json')
    })
  }

  $('select.color-picker').each(function () {
    colorpicker(this)
  })

  var fc = $('#finder_collapse', context)

  if (fc.length !== 0) {
    console.log('found a collapser in a finder')
    var elems = $('.collapsable', context)
    elems.hide()

    fc.click(function () {
      var s = fc.data('state')
      if (s === undefined) {
        fc.data('state', 'collapsed')
        s = 'collapsed'
      }

      var classAnim = 'webkitAnimationEnd mozAnimationEnd ' +
        'MSAnimationEnd oanimationend animationend'
      if (s === 'collapsed') {
        var t = fc.data('non_collapsed_text')
        fc.text(t)
        fc.data('state', 'non-collapsed')
        elems.show(0)
        elems.toggleClass('bounceInLeft animated')
        fc.prop('disabled', true)
        elems.one(classAnim, function (e) {
          $(e.target).removeClass('bounceInLeft animated')
          fc.prop('disabled', false)
        })
      } else {
        var t = fc.data('collapsed_text')
        fc.text(t)
        fc.data('state', 'collapsed')
        elems.toggleClass('bounceOutLeft animated')
        fc.prop('disabled', true)
        elems.one(classAnim, function (e) {
          $(e.target).removeClass('bounceOutLeft animated')
          $(e.target).hide(0)
          fc.prop('disabled', false)
        })
      }
    })
  }

  var logAnyone = $('#anyone')
  if (logAnyone !== 0) {
    logAnyone.click(function () {
      var who = prompt('Username')
      if (who != null) {
        $('[name="auth.username"]').val('testing+' + who + '@daktylios.com')
        $('[name="auth.password"]').val('x')
        notify.clear()
        $('#login_form').submit()
      }

    })
  }

  $('form.crud-form:not(".dont-protect")', context).each(function () {
    var $form = $(this)
    console.log('Data-loss protection for crud-form:')
    console.log(this)
    yp.updateFormInitialData(this)
    $(window).on('beforeunload', function () {
      var d1 = $form.data('serial')
      if (d1 != null && d1 != '') {
        var d2 = yp.serialize($form)
        if (d1 != d2) {
          return text('misc.exitDiscardChanges')
        }
      }
    })
  })

  $('#highcontrast', context).click(function () {
    var c = cookie.get('highcontrast')
    if (c === undefined || c == false) {
      cookie.set('highcontrast', true)
      console.log('highcontrast true')
    } else {
      cookie.set('highcontrast', false)
      console.log('highcontrast false')
    }
    location.reload()
  })

  $('.sortable', context).each(function (x, y) {
    sortable(y)
  })

  var chartClick = function (index, element) {
    console.log('clicked on element ' + index)
    var url = element.data('click-url')
    console.log('base url is ' + url)
    var ids = element.data('ids')
    console.log('ids vector is [' + ids.join(', ') + ']')
    url = url.replace(/_ID_/, ids[index])
    console.log('full url is ' + url)
    yp.emulateLinkClick(url, true)
  }

  $('.chart-histogram').each(function () {
    chart.histogram($(this), chartClick)
  })

  $('.chart-pie').each(function () {
    chart.pie($(this), chartClick)
  })

  $('.chart-points').each(function () {
    chart.points($(this), chartClick)
  })

  var fetchCarousel = function (uid, type, value) {
    fetch(ctx + '/y/user/' + uid +
      '/update_carousels?json&user.shownCarousel' + type +
      '=' + value, {
      method: 'POST',
      headers: csrf(),
    }).
    then(response => response.json()).
    then(data => console.log(data))
  }

  $('#carousel-default .carousel-hide span', context).click(function (x) {
    var car = $('section.carousel-default')
    car.hide()
    var uid = car.data('user-id')
    var type = car.data('type')
    if (type == 'student') {
      fetchCarousel(uid, 'Cv', 'true')
    } else if (car.data('type') == 'company') {
      fetchCarousel(uid, 'Company', 'true')
    }
    $('#show-carousel').show()
  })

  $('#show-carousel a', context).click(function (x) {
    var car = $('section.carousel-default')
    car.show()
    var uid = car.data('user-id')
    var type = car.data('type')
    if (type == 'student') {
      fetchCarousel(uid, 'Cv', 'false')
    } else if (car.data('type') == 'company') {
      fetchCarousel(uid, 'Company', 'false')
    }
    $('#show-carousel').hide()
  })

  $('form.crud-form', context).each(function () {
    yp.updateFormInitialData(this)
  })

  $('.sound-record', context).each(function (e) {
    var $this = $(this)
    soundRecord.init({
      ctx: ctx,
      elem: $this,
      initFinCallback: function () {
        console.log('initFinCallback for sound-record:')
        console.log($this)
        $this.parents('form.crud-form').each(function () {
          yp.updateFormInitialData(this)
        })
      },
      yp: yp,
    })
  })

  $('.entity-speaker.view-view_ready_items', context).each(function (x, y) {
    console.log('speaker')
    speaker.init({
      yp: yp,
      ctx: ctx,
      view: $(y),
    })
  })

  yp.loadAndShow()
  $('form.hide').removeClass('hide')
  _load_ = true
}
